import AllStrainsList from "./AllStrainsList.vue";

/**
 * Register global Vue components below and they will be auto-registered
 * with the root instance.
 */
export default {
    'all-strains-list': AllStrainsList
};
